import MarketingAgentsChat from './MarketingAgentsChat'
import { STORYBOARD_REPLACEMENT_PRESET } from './chatPresets'

export function StoryboardReplacementEngine() {
  return <MarketingAgentsChat preset={STORYBOARD_REPLACEMENT_PRESET} />
}

export default StoryboardReplacementEngine
